import { createCrudActions } from '../utils/crudGenerator';

const formatFinishedproducts = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchFinishedproducts,
    create: createFinishedproduct,
    update: updateFinishedproduct,
    delete: deleteFinishedproducts
} = createCrudActions('FINISHEDPRODUCT', "ProductosAcabado", formatFinishedproducts);